
<template>
  <div>
    <v-container grid-list-xs>
      <v-card style="border-radius:12px">
        <v-card-text>
          <department-list></department-list>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'PageDepartmentList',
  components: {
    DepartmentList: () => import('@/components/department/list/DepartmentList.vue'),
  },
  data() {
    return {
      
    }
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>